import React from "react";
import { cn } from "../../lib/utils.ts"; // Asegúrate de que esta ruta sea correcta

const variantStyles = {
  active: {
    bg: "bg-status-active/10 hover:bg-status-active/20",
    border: "border-status-active/30",
    icon: "bg-status-active/20 text-status-active",
    text: "text-status-active",
    activeBorder: "ring-2 ring-status-active ring-offset-2",
  },
  warning: {
    bg: "bg-status-warning/10 hover:bg-status-warning/20",
    border: "border-status-warning/30",
    icon: "bg-status-warning/20 text-status-warning",
    text: "text-status-warning",
    activeBorder: "ring-2 ring-status-warning ring-offset-2",
  },
  urgent: {
    bg: "bg-status-urgent/10 hover:bg-status-urgent/20",
    border: "border-status-urgent/30",
    icon: "bg-status-urgent/20 text-status-urgent",
    text: "text-status-urgent",
    activeBorder: "ring-2 ring-status-urgent ring-offset-2",
  },
  expired: {
    bg: "bg-status-expired/10 hover:bg-status-expired/20",
    border: "border-status-expired/30",
    icon: "bg-status-expired/20 text-status-expired",
    text: "text-status-expired",
    activeBorder: "ring-2 ring-status-expired ring-offset-2",
  },
  maintenance: {
    bg: "bg-status-maintenance/10 hover:bg-status-maintenance/20",
    border: "border-status-maintenance/30",
    icon: "bg-status-maintenance/20 text-status-maintenance",
    text: "text-status-maintenance",
    activeBorder: "ring-2 ring-status-maintenance ring-offset-2",
  },
};

export function KPICard({
  title,
  value,
  icon: Icon,
  variant = "active",
  onClick,
  isActive,
}) {
  const styles = variantStyles[variant] || variantStyles.active;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-full p-4 rounded-xl border transition-all duration-200 text-left",
        "bg-white shadow-sm", // Cambiado bg-card por bg-white si no tienes bg-card definido
        styles.bg,
        styles.border,
        isActive && styles.activeBorder,
        onClick && "cursor-pointer",
      )}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className={cn("text-3xl font-bold mt-1", styles.text)}>{value}</p>
        </div>
        <div className={cn("p-3 rounded-lg", styles.icon)}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
    </button>
  );
}
